export default __webpack_public_path__ + "static/logo-f77132bd4fb9c01c82c24c1f37da37d0.svg";